import { useQuery } from "@tanstack/react-query";
import { taskKeys } from "../task.keys";
import { taskApi } from "../service";

export function useTaskDetail(id: number | undefined) {
  return useQuery({
    queryKey: taskKeys.detail(id!),
    queryFn: () => taskApi.getById(id!).then((r) => r.data),
    enabled: !!id,
  });
}
